import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, IconButton, Rating, Typography, useMediaQuery } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

const testimonials = [
    {
        comment: 'This platform has transformed the way we manage our business!',
        rating: 4,
        name: 'Nigamanu Suribabu',
        designation: 'Dairy Owner',
    },
    {
        comment: 'Very easy and good app for milk collection',
        rating: 5,
        name: 'Ashok Banjara',
        designation: 'Dairy Owner',
    },
    {
        comment: 'best app...if you want add daily milk sell report and add expenses etc then you are stand on right plateform.aap online ',
        rating: 5,
        name: 'Er shahid Malik',
        designation: 'Dairy Owner',
    },
    {
        comment: 'Excellent support and easy-to-use interface.',
        rating: 5,
        name: 'Neeraj Patel',
        designation: 'Bussinessman',
    },
    {
        comment: 'Excellent support and easy-to-use interface.',
        rating: 5,
        name: 'Ravi Gurjar',
        designation: 'Entrepreneur',
    },
    {
        comment: 'Excellent support and easy-to-use interface.',
        rating: 5,
        name: 'Krishnapal Arya',
        designation: 'Bussinessman',
    },
    {
        comment: 'Best for dairy owner who have to manage a/c of farmers. There is many features how help you and make u to work as smart. Discover the app and make you work easy as you want.. Fine',
        rating: 5,
        name: 'Krishna Pawar',
        designation: 'Dairy Bussinessman',
    },
    {
        comment: 'Excellent support and easy-to-use interface.',
        rating: 5,
        name: 'Vikas Patel',
        designation: 'Dairy Owner',
    },

];

const TestimonialComment = () => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const [index, setIndex] = useState(1);
    const [transitioning, setTransitioning] = useState(true);
    const timeoutRef = useRef(null);
    const length = testimonials.length;
    const isTransitioningRef = useRef(false);


    const extendedSlides = [
        testimonials[length - 1],
        ...testimonials,
        testimonials[0],
    ];

    const handleNext = () => {
        if (transitioning && !isTransitioningRef.current) {
            isTransitioningRef.current = true;
            setIndex((prev) => prev + 1);
            resetTimeout();
        }
    };

    const handlePrev = () => {
        if (transitioning && !isTransitioningRef.current) {
            isTransitioningRef.current = true;
            setIndex((prev) => prev - 1);
            resetTimeout();
        }
    };


    const resetTimeout = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            handleNext();
        }, 5000);
    };


    const handleTransitionEnd = () => {
        isTransitioningRef.current = false;

        if (index === 0) {
            setTransitioning(false);
            setIndex(length);
        } else if (index === length + 1) {
            setTransitioning(false);
            setIndex(1);
        }
    };

    useEffect(() => {
        if (!transitioning) {
            const id = setTimeout(() => {
                setTransitioning(true);
            }, 20);
            return () => clearTimeout(id);
        }
    }, [transitioning]);


    const touchStartX = useRef(null);
    const touchEndX = useRef(null);

    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchMove = (e) => {
        touchEndX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
        if (!touchStartX.current || !touchEndX.current) return;
        const distance = touchStartX.current - touchEndX.current;
        if (Math.abs(distance) > 50) {
            if (distance > 0) {
                handleNext();
            } else {
                handlePrev();
            }
        }
        touchStartX.current = null;
        touchEndX.current = null;
    };


    return (
        <Box
            sx={{
                width: { xs: '90%', md: '70%' },
                backgroundColor: 'white',
                mx: 'auto',
                overflow: 'hidden',
                position: 'relative',
                background: 'transparent',
            }}
        >
            {!isMobile && (
                <IconButton
                    onClick={handlePrev}
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: 10,
                        transform: 'translateY(-50%)',
                        zIndex: 2,
                        bgcolor: '#1565c0',
                        color: 'white',
                        borderRadius: '50%',
                        '&:hover': {
                            bgcolor: '#1565c0',
                        },
                    }}
                >
                    <ArrowForwardIcon sx={{ transform: 'rotate(180deg)' }} />
                </IconButton>
            )}

            {!isMobile && (
                <IconButton
                    onClick={handleNext}
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        right: 10,
                        transform: 'translateY(-50%)',
                        zIndex: 2,
                        bgcolor: '#1565c0',
                        color: 'white',
                        borderRadius: '50%',
                        '&:hover': {
                            bgcolor: '#1565c0',
                        },
                    }}
                >
                    <ArrowForwardIcon />
                </IconButton>
            )}

            <Box
                sx={{
                    display: 'flex',
                    width: `${extendedSlides.length * 100}%`,
                    transform: `translateX(-${index * (100 / extendedSlides.length)}%)`,
                    transition: transitioning ? 'transform 0.6s ease-in-out' : 'none',
                }}
                onTransitionEnd={handleTransitionEnd}
                onTouchStart={isMobile ? handleTouchStart : undefined}
                onTouchMove={isMobile ? handleTouchMove : undefined}
                onTouchEnd={isMobile ? handleTouchEnd : undefined}
            >

                {extendedSlides.map((item, i) => (
                    item && (
                        <Box
                            key={i}
                            sx={{
                                width: `${100 / extendedSlides.length}%`,
                                flexShrink: 0,
                                textAlign: 'center',
                                px: 2,
                                fontFamily: 'Nunito',
                            }}
                        >
                            <Typography
                                variant="body1"
                                fontSize={'16px'}
                                color="#686868"
                                fontWeight={400}
                                textAlign="center"
                                sx={{ mt: 4, fontFamily: 'Nunito, sans-serif' }}
                            >
                                “{item.comment}”
                            </Typography>
                            {/* <p fontSize={'18px'} fontWeight={600}  color='#041424' gutterBottom>
                                “{item.comment}”
                            </p> */}
                            <Rating value={item.rating} readOnly size="medium" />
                            <Typography variant="h5" color='#041424' fontFamily={'Rajdhani'} fontSize={'20px'}>
                                {item.name}
                            </Typography>
                            <Typography variant="body2" color="#686868" fontSize={'16px'} fontFamily={'Nunito'}>
                                {item.designation}
                            </Typography>
                        </Box>
                    )
                ))}
            </Box>
        </Box>
    );
};

export default TestimonialComment;
